import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { Actions as LocationActions } from 'actions/shared/location'
import { Actions as PageActions } from 'actions/page'
import * as Selectors from 'selectors/page'
import type { Page } from 'types/Page'
import 'types/Page'
const mapStateToProps = createStructuredSelector({
  isReady: Selectors.getPageIsReady,
  page: Selectors.getPage,
  pageData: Selectors.getPageData,
  pageName: Selectors.getPageName,
  pageParams: Selectors.getPageParams,
})

const mapDispatchToProps = (dispatch) => ({
  setLocation: (location: string) => dispatch(LocationActions.SET_LOCATION(location)),
  setPage: (page: Page) => dispatch(PageActions.SET(page)),
  setPageData: (data: Record<string, any>) => dispatch(PageActions.SET_DATA(data)),
})

export type ConnectorProps = {
  isReady: boolean
  page: Record<string, any>
  pageData: Record<string, any>
  pageName: string
  pageParams: Record<string, any>
  setLocation: (...args: Array<any>) => any
  setPage: (...args: Array<any>) => any
  setPageData: (...args: Array<any>) => any
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect